// Maximální šířka okna pro zobrazení modálního okna místo zoom efektu
const MAX_WIDTH_TO_SHOW_ZOOM_LEAFLET_MODAL = 768;

// ID elementů
const ZOOM_ICON_CLASS = 'leaflet-zoom-icon';
const LEAFLET_IMAGE_WRAPPER_ID = 'leaflet-image-wrapper';
const LEAFLET_ZOOM_MODAL_ID = 'leaflet-zoom-modal';
const PRODUCT_PAGE_ID = 'product-page';

// třídy
const LEAFLET_ZOOM_ENABLED_CLASS = 'leaflet-image-wrapper--zoom';
const ZOOM_ICON_ZOOM_IN_CLASS = 'leaflet-zoom-icon--zoom-in';
const ZOOM_ICON_ZOOM_OUT_CLASS = 'leaflet-zoom-icon--zoom-out';

export const initZoomLeaflet = () => {
    const zoomIconElements = document.getElementsByClassName(ZOOM_ICON_CLASS);

    if (!zoomIconElements || !zoomIconElements.length === 0) {
        return;
    }

    for (const zoomIconElement of zoomIconElements) {
        zoomIconElement.addEventListener('click', onZoomIconClick);
    }
}

const onZoomIconClick = () => {
    const shouldShowModal = window.innerWidth <= MAX_WIDTH_TO_SHOW_ZOOM_LEAFLET_MODAL;

    if (shouldShowModal) {
        showModalLeaflet();
    } else {
        enableZoomMode();
    }
}

const enableZoomMode = () => {
    const zoomIconElements = document.getElementsByClassName(ZOOM_ICON_CLASS);
    const leafletImageWrapperElement = document.getElementById(LEAFLET_IMAGE_WRAPPER_ID);

    const haveElementsForZoomMode = leafletImageWrapperElement && zoomIconElements && zoomIconElements.length > 0;

    if (!haveElementsForZoomMode) {
        return;
    }

    const haveZoomClass = leafletImageWrapperElement.classList.contains(LEAFLET_ZOOM_ENABLED_CLASS);
    const haveZoomInClass = zoomIconElements[0].classList.contains(ZOOM_ICON_ZOOM_IN_CLASS);

    // Přidání / odstranění posluchačů pro zoom letáku
    if (haveZoomClass) {
        removeZoomListeners(leafletImageWrapperElement);
    } else {
        addZoomListeners(leafletImageWrapperElement);
    }

    for (const zoomIconElement of zoomIconElements) {
        // styly ikony zoomu
        zoomIconElement.classList.remove(haveZoomInClass ? ZOOM_ICON_ZOOM_IN_CLASS : ZOOM_ICON_ZOOM_OUT_CLASS);
        zoomIconElement.classList.add(haveZoomInClass ? ZOOM_ICON_ZOOM_OUT_CLASS : ZOOM_ICON_ZOOM_IN_CLASS);
    }

    // styly pro zoom obrázku
    leafletImageWrapperElement.classList.toggle(LEAFLET_ZOOM_ENABLED_CLASS);

    toggleProductsPageElement(haveZoomClass);
}

const toggleProductsPageElement = (isPrevInZoomMode) => {
    const productsPageElement = document.getElementById(PRODUCT_PAGE_ID);

    if (!productsPageElement) {
        return;
    }

    productsPageElement.style.display = isPrevInZoomMode ? 'block' : 'none';
}

const zoom = (e) => {
    const zoomer = e.currentTarget;

    const haveAllNecessaryPropertiosToZoom = !zoomer || !e.offsetHeight || !e.offsetY || !zoomer.offsetWidth || !zoomer.offsetHeight;

    if (!haveAllNecessaryPropertiosToZoom) {
        return;
    }

    const x = (e.offsetX / zoomer.offsetWidth) * 100;
    const y = (e.offsetY / zoomer.offsetHeight) * 100;

    zoomer.style.backgroundPosition = `${x}% ${y}%`;
    if (zoomer.cssText) {
        zoomer.style.backgroundImage = zoomer.cssText.replace('background-image: ', '');
    }
}

const showModalLeaflet = () => {
    const leafletZoomModalElement = document.getElementById(LEAFLET_ZOOM_MODAL_ID);

    if (!leafletZoomModalElement) {
        return;
    }

    $(`#${LEAFLET_ZOOM_MODAL_ID}`).modal('show');
}

const touchZoom = (event) => {
    try {
        event.preventDefault();
        const zoomer = event.currentTarget;
    
        const rect = event.target.getBoundingClientRect();
    
        const zoomerEventX = event.targetTouches[0].pageX - (rect.left + document.documentElement.scrollLeft);
        const zoomerEventY = event.targetTouches[0].pageY - (rect.top + document.documentElement.scrollTop);
    
        const x = (zoomerEventX > rect.width ? rect.width : zoomerEventX < 0 ? 0 : zoomerEventX) / zoomer.offsetWidth * 100;
        const y = (zoomerEventY > rect.height ? rect.height : zoomerEventY < 0 ? 0 : zoomerEventY) / zoomer.offsetHeight * 100;
    
        zoomer.style.backgroundPosition = `${x}% ${y}%`;
    } catch (_err) {}
}

const addZoomListeners = (leafletImageWrapperElement) => {
    leafletImageWrapperElement.addEventListener('mousemove', zoom);
    leafletImageWrapperElement.addEventListener('touchmove', touchZoom);
}

const removeZoomListeners = (leafletImageWrapperElement) => {
    leafletImageWrapperElement.removeEventListener('mousemove', zoom);
}
